import { defineComponent as _defineComponent } from 'vue'
import CommonButton from '@/components/CommonButton.vue';
import { inject, onMounted, Ref, ref } from 'vue';
import CommonInput from '../CommonInput.vue';
import { AdminUser } from '@/models/admins/admin_model';
import { useEditHrAdmin } from '@/stores/users/edit_hr_admin_store';
import AlertModal from '@/components/modals/AlertModal.vue';
import LoadingModal from '@/components/modals/LoadingModal.vue';
import { AlertModalInjection, AlertModalInjectionV2, LoadingModalInjection } from '@/infra/constants/injections';
import AlertModalV2 from '../modals/AlertModalV2.vue';
import { Icons } from '@/font-awesome';


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonalInformationContent',
  props: {
    currentPage: { type: Number, required: true },
    adminUser: { type: Object, required: true },
    qrCodeUrl: { type: String, required: true },
    secret: { type: String, required: true }
  },
  emits: ["change-page", "on-submit"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

let editHrAdmin = useEditHrAdmin();
const alertModalV2 = inject<Ref<InstanceType<typeof AlertModalV2>>>(AlertModalInjectionV2);
const loadingModal = inject<Ref<InstanceType<typeof LoadingModal>>>(LoadingModalInjection);
const fixedIcon = Icons.imported.faCircleExclamation;
const zIndexRef = ref<number>(2);



// async function setUserData() {
//   editHrAdmin.firstName = props.adminUser.getFirstName() ?? '';
//   editHrAdmin.lastName = props.adminUser.getLastName() ?? '';
//   editHrAdmin.phone = props.adminUser.getPhone() ?? '';
// }

async function saveParsonalInfo() {
  try {
    loadingModal?.value?.open();
    const res = await editHrAdmin.submit();
    if(!res) return;
    if (res?.isError()) alertModalV2?.value?.open({
        zIndex: 10000,
        title: 'Informação Incorreta',
        size: 'medium',
        icon: fixedIcon,
        modalType: 'error',
        content: 'Erro ao salvar informação, este número de telefone já foi cadastrado.'
      });
    else {
      editHrAdmin.$reset();
      emit('change-page', props.currentPage + 1);
    }
  }
  finally {
    loadingModal?.value?.close();
  }
}

// onMounted(() => {
//   setUserData();
// })

const emit = __emit;


const __returned__ = { props, get editHrAdmin() { return editHrAdmin }, set editHrAdmin(v) { editHrAdmin = v }, alertModalV2, loadingModal, fixedIcon, zIndexRef, saveParsonalInfo, emit, CommonButton, CommonInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})